import api from "./api";

export const getDashboardData = async () => {
  const response = await api.get("dashboard/");
  return response.data;
};

export const getAttendanceSummary = async (params = {}) => {
  const response = await api.get("dashboard/attendance-summary/", { params });
  return response.data;
};
